import AbstractLanguage from './AbstractLanguage';

// The birthday present page the Slack invite links to.
export default class BirthdayWish extends AbstractLanguage {
  // '2026-10-08' -> '8 October' / '8 октября' / '8 жовтня'. Parsed as local noon so no
  // timezone can move it onto the neighbouring day.
  date(date: string) {
    const locale = this.getText({ EN: 'en-GB', RU: 'ru', UA: 'uk' });
    return new Date(`${date}T12:00:00`).toLocaleDateString(locale, {
      day: 'numeric',
      month: 'long',
      weekday: 'long',
    });
  }

  get title() {
    return this.getText({
      EN: 'Birthday present',
      RU: 'Подарок на день рождения',
      UA: 'Подарунок на день народження',
    });
  }

  intro(date: string) {
    const day = this.date(date);
    return this.getText({
      EN: `Your birthday is on ${day}. What would you like as a present?`,
      RU: `Твой день рождения — ${day}. Что хочешь в подарок?`,
      UA: `Твій день народження — ${day}. Що хочеш у подарунок?`,
    });
  }

  hint(budget: number) {
    return this.getText({
      EN: `A link to the exact thing works best, but plain text is fine too. The budget is $${budget}. `
        + `If it costs more, that's fine as well: we'll add $${budget} to your salary and you buy it yourself.`,
      RU: `Лучше всего — ссылка на конкретную вещь, но можно и просто текстом. Бюджет — $${budget}. `
        + `Если подарок дороже — тоже ок: добавим $${budget} к зарплате, и купишь его сам.`,
      UA: `Найкраще — посилання на конкретну річ, але можна й просто текстом. Бюджет — $${budget}. `
        + `Якщо подарунок дорожчий — теж ок: додамо $${budget} до зарплати, і купиш його самостійно.`,
    });
  }

  get placeholder() {
    return this.getText({
      EN: 'https://… or describe what you would like',
      RU: 'https://… или опиши, что хочешь',
      UA: 'https://… або опиши, що хочеш',
    });
  }

  get label() {
    return this.getText({
      EN: 'Your wish',
      RU: 'Твоё пожелание',
      UA: 'Твоє побажання',
    });
  }

  until(date: string) {
    const day = this.date(date);
    return this.getText({
      EN: `You can change it until ${day}, inclusive.`,
      RU: `Изменить можно до ${day} включительно.`,
      UA: `Змінити можна до ${day} включно.`,
    });
  }

  opens(date: string) {
    const day = this.date(date);
    return this.getText({
      EN: `This opens on ${day}, about a week before your birthday — you'll get a Slack message.`,
      RU: `Откроется ${day}, примерно за неделю до дня рождения — придёт сообщение в Slack.`,
      UA: `Відкриється ${day}, приблизно за тиждень до дня народження — прийде повідомлення в Slack.`,
    });
  }

  get closed() {
    return this.getText({
      EN: 'Wishes for this birthday are closed.',
      RU: 'Пожелания на этот день рождения уже закрыты.',
      UA: 'Побажання на цей день народження вже закриті.',
    });
  }

  get no_birthday() {
    return this.getText({
      EN: 'Your birthday is not set in the CRM yet. Ask HR to add it.',
      RU: 'Твой день рождения ещё не указан в CRM. Попроси HR добавить его.',
      UA: 'Твій день народження ще не вказаний у CRM. Попроси HR додати його.',
    });
  }

  get save() {
    return this.getText({ EN: 'Save', RU: 'Сохранить', UA: 'Зберегти' });
  }

  get saved() {
    return this.getText({
      EN: 'Saved. The admins have been told.',
      RU: 'Сохранено. Админы получили уведомление.',
      UA: 'Збережено. Адміни отримали сповіщення.',
    });
  }

  get save_failed() {
    return this.getText({
      EN: 'Could not save. Try again.',
      RU: 'Не удалось сохранить. Попробуй ещё раз.',
      UA: 'Не вдалося зберегти. Спробуй ще раз.',
    });
  }
}
